import React, { useState, useContext, useEffect } from "react";
import "./NewUser.css";
import { Link, useHistory } from "react-router-dom";
import logo from "../../../../assets/images/morvarid.png";
import { Card, Row, Col, Button, Form as formstyle } from "react-bootstrap";
//@ts-ignore
import PNotify from "pnotify/dist/es/PNotify";
import Api from "@model/Api";
import { ConfigContext } from "@contexts/ConfigContext";
import InputMask from "react-input-mask";
import { useTimer } from "react-timer-hook";
import AuthService from "@model/AuthService";

const NewUser = (p: any) => {
  const { setShowModal, setShowModalRegister } = p;
  const configContext = useContext(ConfigContext);
  //@ts-ignore
  const { dispatch } = configContext;
  const history = useHistory();
  const [mobileCode, setMobileCode] = useState<string>();
  const [showMobileCode, setShowMobileCode] = useState(false);
  const [mobile, setMobile] = useState<string>();
  const [fullName, setFullName] = useState<string>();
  const [loginError, setLoginError] = useState("");
  const [isSubmitMobile, setIsSubmitMobile] = useState<boolean>();// onMobileFormSubmit
  const [isSubmitCode, setIsSubmitCode] = useState<boolean>();// onMobileCodeFormSubmit

  const time = new Date();
  time.setSeconds(time.getSeconds() + 120);
  const { seconds, minutes, isRunning, restart } = useTimer({
    expiryTimestamp: time,
  });


  async function onMobileFormSubmit(e: any) {
    e.preventDefault();
    setIsSubmitMobile(true)
    new Api()
      .get(`/api/website/sendsmstoVerify/${mobile}`)
      .then(async (response) => {
        const data = await response.json();
        if (response.status === 200) {
          setTimeout(() => {
            setIsSubmitMobile(false)
          }, 2000);
          setShowMobileCode(true);
          const time = new Date();
          time.setSeconds(time.getSeconds() + 120);
          restart(time);
        } else {
          PNotify.error({
            title: "عملیات ناموفق",
            text: data.errors[0].msg,
          });
        }
      });
    setLoginError("");
  }

  async function onMobileCodeFormSubmit(e: any) {
    setIsSubmitCode(true)
    e.preventDefault();
    new Api()
      .put(`/api/website/verifyMobile/userRegister`, {
        body: JSON.stringify({
          mobileCode, mobile, fullName
        })
      })
      .then(async (response) => {
        const data = await response.json();
        if (response.status === 200) {
          setTimeout(() => {
            setIsSubmitCode(false)
          }, 2000);

          dispatch({
            type: "LOGIN",
            openLoginForm: false,
          });
          PNotify.success({
            title: "عملیات موفق",
            text: "شماره موبایل تایید و ثبت نام با موفقیت انجام شد.",
          });
          const profileInfo: any = await new AuthService().login({
            username: data.newCustomer.username,
            password: data.password,
            rememberMe: true,
          });

          if (profileInfo) {
            setShowModal(false);
            history.replace("/");
            setShowModalRegister(false)
            PNotify.success({
              title: "عملیات موفق",
              text: "به سیستم وارد شدید.",
            });
            dispatch({
              type: "LOGIN",
              openLoginForm: false,
            });
          }
        }
      });
    setLoginError("");
  }

  return (
    <section className="auth-wrapper">
      <Row className="align-items-center text-center">
        <Col md={12} className="p-5">
          <Row className="align-items-center text-center">
            <Col md={12}>
              <img
                id="main-logo"
                src={logo}
                style={{ height: "100px" }}
                alt="لوگو رستوران مروارید"
                className="logo"
              />
            </Col>
          </Row>
          <Row className="align-items-center text-center">
            <Col md={12} className="p-3">
              <p className="reg-title">
                ثبت نام
              </p>
            </Col>
          </Row>
          {!showMobileCode ? (
            <Row className="p-0">
              <Col className="p-0">
                <Card.Body>
                  {" "}
                  <h4 className="mb-3 f-w-200">شماره موبایل را وارد کنید</h4>
                  <form onSubmit={onMobileFormSubmit}
                  >
                    <Row>
                      <InputMask
                        style={{ direction: "ltr" }}
                        autoFocus
                        className="form-control text-center mb-2"
                        mask=" 0\999  999  99  99"
                        name="mobile"
                        alwaysShowMask
                        value={mobile}
                        onChange={(e: any) => {
                          const mo = (e.target.value as string).replace(
                            /\D/g,
                            ""
                          );
                          setMobile(mo);
                        }}
                      />
                    </Row>
                    <Row className="mb-3">
                      <input
                        type="text"
                        name="fullName"
                        className="form-control"
                        placeholder="نام و نام خانوادگی"
                        onChange={(e: any) =>
                          setFullName(e.target.value)
                        }
                      />
                      {!fullName &&
                        <span className="text-c-red f-12">
                          نام و نام خانوادگی را وارد کنید
                        </span>
                      }
                    </Row>
                    {loginError && (
                      <div
                        style={{
                          padding: 5,
                          borderRadius: 7,
                          margin: 7,
                          color: "#ff6161",
                        }}
                      >
                        {loginError}
                      </div>
                    )}
                    <button
                      disabled={!((mobile && mobile.length == 11) && fullName) || isSubmitMobile}
                      type="submit"
                      className={`btn btn-block mb-3 ${!((mobile && mobile.length == 11 && fullName)) || isSubmitMobile
                        ? "btn-outline-success"
                        : "btn-success"
                        }`}
                    >
                      {isSubmitMobile ? (
                        <div
                          className="spinner-grow spinner-grow-sm"
                          style={{ marginBottom: "3px" }}
                          role="status"
                        >
                        </div>
                      ) : (
                        "دریافت کد "
                      )}
                    </button>
                  </form>
                </Card.Body>
              </Col>
            </Row>
          ) : showMobileCode && (
            <Card.Body>
              {" "}
              <h4 className="mb-3 f-w-200">
                کد ارسال شده به موبایل خود را وارد کنید
              </h4>
              <form onSubmit={onMobileCodeFormSubmit}>
                <InputMask
                  style={{ direction: "ltr" }}
                  autoFocus
                  className="form-control text-center mb-2"
                  mask="9999"
                  name="code"
                  alwaysShowMask
                  value={mobileCode}
                  onChange={(e: any) => {
                    const code = (e.target.value as string).replace(
                      /\D/g,
                      ""
                    );
                    setMobileCode(code);
                  }}
                />
                {loginError && (
                  <div
                    style={{
                      padding: 5,
                      borderRadius: 7,
                      margin: 7,
                      color: "#ff6161",
                    }}
                  >
                    {loginError}
                  </div>
                )}

                <div style={{ display: "flex", justifyContent: "center" }}>
                  <p>
                    {" "}
                    <span className="f-14"> زمان باقیمانده: </span>
                    <span className="f-14 text-info">
                      {minutes}:{seconds}
                    </span>
                    {!isRunning && (
                      <Button
                        variant="link"
                        className="mr-2 p-0 f-12"
                        style={{ textDecoration: "none" }}
                        onClick={onMobileFormSubmit}
                      >
                        <span className="text-info">ارسال دوباره</span>
                        <i className="fas fa-undo text-info mr-1" />
                      </Button>
                    )}
                  </p>
                </div>

                <button
                  disabled={!(mobileCode && mobileCode.length == 4) || isSubmitCode}
                  className={`btn btn-block mb-3 ${!(mobileCode && mobileCode.length == 4) || isSubmitCode
                    ? "btn-outline-success"
                    : "btn-success"
                    }`}
                  type="submit"
                >
                  {isSubmitCode ? (
                    <div
                      className="spinner-grow spinner-grow-sm"
                      style={{ marginBottom: "3px" }}
                      role="status"
                    >
                    </div>
                  ) : (
                    "تایید کد "
                  )}

                </button>
              </form>
            </Card.Body>
          )}
        </Col>
      </Row >
    </section >
  );
};
export default React.memo(NewUser);
